import React from 'react'
import './ItemRowCard.scss'
import ItemCardClickableProperty from './generic/ItemRowCardClickableProperty'
import {SearchItem} from '../../../model/SearchItem'
import {useDatxPathGenerator} from '../../../../util/routing'
import {ROUTES} from '../../../../constants/routing'
import ItemNature from './ItemMainProperties/ItemNature'
import AddToListButton from '../../../../genericComponents/AddToListButton'

export const ItemRowHeaderCard = ({
                                      item,
                                      handleAddSingleItemToList,
                                      highlightPhrase,
                                      showAddToListButton = true
                                  }: {
    item: SearchItem,
    handleAddSingleItemToList: (item: SearchItem) => void,
    highlightPhrase?: string | null,
    showAddToListButton?: boolean
}) => {
    const generatePath = useDatxPathGenerator()

    return (
        <div className={'item-row-header-card'} data-testid={item.id}>

                <div className={'item-row-card-action-box'}>
                    <ItemNature nature={item.nature}/>
                    {showAddToListButton && (<AddToListButton onClick={() => handleAddSingleItemToList}/>)}
                </div>


            <ItemCardClickableProperty
                highlightPhrase={highlightPhrase || ''}
                value={item.partNumber}
                linkTo={generatePath(ROUTES.detailItem.path, {itemId: item.id})}
                testId={`link-${item.id}`}
            />
        </div>
    )
}